import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 站头、加好友入口的公共样式：与 App.vue 内的布局类对应，随主样式一起打包。
import './content/prerendered.css'

const app = createApp(App)
app.use(router)
app.mount('#app')
